import { Breadcrumb, Card, Col, Row, Typography } from 'antd';
import { SummaryContainer } from '../components/summary.container';
import { HeaderSummaryContainer } from '../components/header-summary.container';
import { HeaderDetailContainer } from '../components/header-detail.container';
import { CollapsibleApplicantProfileArchivedContainer } from '../components/collapsible-applicant-profile-archived.container';
import { RelatedCasesTabContainer } from '../../v1/components/related-cases-tab.container';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import { SubPageLayout } from '../../../../staff/sub-page-layout';

const { Title } = Typography;
interface ArchivedSummaryLayoutProps {
  archivedCaseId: string;
  isApplicantSection?: boolean;
}
export const ArchivedSummaryLayout: React.FC<ArchivedSummaryLayoutProps> = (props) => {
  const navigate = useNavigate();
  return (
    <>
      <div
        style={{
          minHeight: '100vh',
          width: '100%',
          paddingLeft: 24,
          paddingRight: 24
        }}
      >
      <SubPageLayout
        header={
          <div id="leftTitle" style={{ display: 'inline', float: 'left' }}>
            <div style={{paddingTop: '24px'}}>
            <Breadcrumb
              className="text-sm"
              separator="/"
              items={[ 
                {
                  title: (
                    <button
                      onClick={() => navigate(-1)}
                      aria-label={`Go back to ${props.isApplicantSection ? 'Applicants' : 'Cases'}`}
                      className="bg-transparent border-none p-0 cursor-pointer outline-none focus:outline-none active:bg-transparent hover:bg-transparent"
                    >
                      {props.isApplicantSection ? 'Applicants' : 'Cases'}
                    </button>
                  )
                },
                { title: 'Credential Verification' }
              ]}
            />
          </div>
            <Title level={3} style={{ display: 'inline' }}>
              Credential Verification
            </Title>
            <span style={{ margin: '0 10px' }}></span>
            <Title level={4} type="secondary" style={{ display: 'inline' }}>
              Credential Verification
            </Title>
          </div>
        }
      >
        <Helmet>
          <title>Staff Portal</title>
        </Helmet>
          {/* Header Section */}
          <Col span={24}>
          <Col style={{ marginBottom: '20px' }}>
            <HeaderSummaryContainer caseId={props.archivedCaseId} />
            <HeaderDetailContainer caseId={props.archivedCaseId} />
          </Col>
          <Row gutter={16}>
          <Col span={15}>
            <div style={{ marginBottom: '20px' }}>
              <CollapsibleApplicantProfileArchivedContainer caseId={props.archivedCaseId ?? ''} />
            </div>
            <SummaryContainer data={{ archivedCaseId: props.archivedCaseId }} />
          </Col>
 
          <Col span={9}>
 
            <Card hoverable style={{ marginBottom: '20px' }}>
              <RelatedCasesTabContainer caseId={props.archivedCaseId ?? ''} isArchived={true} />
            </Card>
 
          </Col>
          </Row>
          </Col>
      </SubPageLayout>
    </div>
    </>
  );
};
